import React from "react";
import { Box, TextField, IconButton, Select, MenuItem, FormControl } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useDispatch } from "react-redux";
import { updateExternalInfo, removeExternalInfo } from "features/OrgAdmin/orgAdminSlice";

export default function ExternalInfoRow({ index, data }) {
  const dispatch = useDispatch();

  const handleChange = (field, value) => {
    dispatch(updateExternalInfo({ index, field, value }));
  };

  const handleRemove = () => {
    dispatch(removeExternalInfo(index));
  };

  const fieldOptions = [
    "Journeys Api",
    "Geofence Api",
    "ETA Api",
    "Attendance Api",
    "Vendor Api Key",
    "Migrate Journeys Api",
    "Update Vehicle Api",
  ];

  return (
    <Box display="flex" alignItems="center" gap={2} width="100%">

      {/* Dropdown Box */}
      <FormControl sx={{ minWidth: "170px" }} size="small">
        <Select
          displayEmpty
          value={data.key || ""}
          onChange={(e) => handleChange("key", e.target.value)}
          sx={{
            fontSize: "0.85rem",
            bgcolor: "#fff",
            borderRadius: "6px",
            height: "40px",                 // 🔥 explicit height
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d2d6da" },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              height: "40px !important",    // 🔥 forces same height as TextField
              boxSizing: "border-box",
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          <MenuItem disabled value="">
            <em>Select API</em>
          </MenuItem>
          {fieldOptions.map((option) => (
            <MenuItem key={option} value={option} sx={{ fontSize: "0.85rem" }}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* URL Value Box */}
      <TextField
        size="small"
        placeholder="Enter URL or Key"
        value={data.value || ""}
        title={data.value}
        onChange={(e) => handleChange("value", e.target.value)}
        sx={{
          flex: 1,
          minWidth: "250px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            height: "40px",               // 🔥 same height as Select
            "& fieldset": { borderColor: "#d2d6da" },
          },
          "& input": {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          },
        }}
        InputProps={{ style: { fontSize: "0.85rem", backgroundColor: "#fff" } }}
      />

      {/* Remove Box */}
      <IconButton
        onClick={handleRemove}
        size="small"
        sx={{ color: "#6b7280", "&:hover": { color: "#ef4444" } }}
      >
        <RemoveCircleOutlineIcon fontSize="medium" />
      </IconButton>
    </Box>
  );
}